export default {
  yandexdirect: 'yandex',
  vk: 'vk',
  googleads: 'adv',
  vkads: 'vk-ads',
}
